import zhHansMessages from "src/locales/zhHans.messages";
import { toNestedMessageIds } from "src/utils/locale";

export default toNestedMessageIds(zhHansMessages);
